import { useMutation, useQueryClient } from "@tanstack/react-query";
import { importManufacturerFile } from "./importManufacturerFile";

export const useImportManufacturerFile = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: importManufacturerFile,
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["manufacturers"]
            });
        }
    });
};
